import { CancelToken } from 'apisauce';
import shortid from 'shortid';
import cn from 'classnames';
import { formatPhoneNumberIntl, formatPhoneNumber as formatLocalPhoneNumber } from 'react-phone-number-input';
import { parse } from 'qs';
import moment from 'moment';

import appConfig from 'src/appConfig';
import { isEmpty } from 'src/validations';
import { Location } from 'history';
import { Option, RoleOption } from 'src/redux/contentRedux/types';
import { JobInfo } from 'src/redux/jobcodes/types';
import { TaskInfo } from 'src/redux/task/types';
import { Callback } from 'src/redux/types';

export function newCancelToken(timeout = appConfig.CONNECTION_TIMEOUT) {
  const source = CancelToken.source();
  setTimeout(() => {
    source.cancel();
  }, timeout);

  return { cancelToken: source.token };
}

export const getRandomId = (): string => shortid.generate();

export const generateArray = (length: number, initial = '') => Array(length).fill(initial);

export const stringify = (params: { [key: string]: number | string | string[] | Callback | boolean }) => {
  let result = '';

  Object.keys(params).forEach(key => {
    if (!isEmpty(params[key])) {
      if (Array.isArray(params[key])) {
        let array = params[key] as string[];
        array.forEach((param: string) => {
          result += `&${key}=${param}`;
        });
      } else {
        result += `&${key}=${params[key]}`;
      }
    }
  });

  result = result.replace(/^&/, '');

  return result;
};

export const getYesNo = (value: boolean, highLightValue = 'YES') => {
  if (isEmpty(value)) return '';
  const result = value ? 'YES' : 'NO';
  const isHighLight = highLightValue === result;
  return <span className={cn({ 'has-text-danger': isHighLight })}>{result}</span>;
};

export const getLocationState = (location: Location<string>) => {
  const locationState = location.state;
  const state = parse(locationState, { ignoreQueryPrefix: true });

  return state;
};

export const formatPhoneNumber = (mobile: string) => {
  if (!mobile) return '';
  try {
    if (mobile.startsWith('+1')) return formatLocalPhoneNumber(mobile);
    return formatPhoneNumberIntl(mobile);
  } catch (error) {
    return '';
  }
};

export const formatDate = (value: string, format: string = 'MM/DD/YYYY') => {
  if (!value) return '';

  return moment(value).format(format);
};

export const getClassNameByStatus = (status: string) => {
  switch (status) {
    case 'Pending':
      return 'is-status-pending ';
    case 'Completed':
    case 'Approved':
    case 'Active':
      return 'is-status-active';
    case 'Rejected':
      return 'is-status-rejected';
    default:
      return '';
  }
};

export const convertStateOptionsToOptions = (options: Option[]) =>
  options.map(option => ({ value: option.id, label: option.value }));

export const convertRoleOptionsToOptions = (options: RoleOption[]) =>
  options.map(item => ({ value: item.id, label: item.name }));

export const LockupValueByLabel = (label: string, options: Array<{ value: number | string; label: string }>) =>
  options.find(item => item.label === label)?.value || null;

export const filterParams = (params: any) => {
  Object.keys(params).forEach(key => {
    if (!params[key]) delete params[key];
  });
  return params;
};

export const convertCodesToOptions = (options: JobInfo[]) =>
  options.map(item => ({ value: item.id || null, label: item.description }));

export const convertTasksToOption = (tasks: TaskInfo[]) =>
  tasks.map(task => ({ label: task.name, value: task.id || null }));

export const getYesNoText = (value: boolean) => (value ? 'Yes' : 'No');

export const formatMoney = (value: number) =>
  value
    .toLocaleString('de-DE', {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 0,
    })
    .replace(/\./g, ',');

export const formatMoneyInput = (value: number) => {
  if (!value) return '';
  return value.toLocaleString('en-US', {
    maximumFractionDigits: 0,
  });
};
export const hourDateFormat = 'h:mm:ss a, MMMM DD, YYYY';
export const monthFormat = 'MMMM DD, YYYY';

export const emptyFunction = () => {};

export const formatArrayToOption = (array: any[]) =>
  array.map(item => ({ label: item.description, value: item.id, name: item.name }));

export const getStatusDisplay = (isActive: boolean) => {
  return isActive ? 'Active' : 'Inactive';
};
